module.exports = __webpack_public_path__ + "0db4aca5f3c3654b291883f2280fe899.png";